import React from 'react';
import classNames from 'classnames';
import ShopIcon from '../assets/images/shop.png';

const appAppStoreUrl = 'https://apps.apple.com/us/app/fast-buyer/id6449710682';
const appAppStoreIconUrl = '/static/app/app_store_solid';
const appGooglePlayUrl = 'https://play.google.com/store/apps/details?id=buyer.fastordernow.com&hl=en_AU&gl=US';
const appGooglePlayIconUrl = '/static/app/google_play_solid';

export const DownloadAppSmall2 = ({ className }) => {
    const iconSize = '50px'; 
    
    return (
        <div className={classNames('d-flex flex-column text-center justify-content-center', {[className]: !!className})}>
            <h3 className="font-weight-bold">Download Our App</h3>
            <div className="d-flex flex-column flex-md-row justify-content-center" style={{gap: '1rem'}}>
                <a href={appAppStoreUrl} target="_blank">
                    <picture>
                        <source srcSet={`${appAppStoreIconUrl}.webp`} type="image/webp"/>
                        <source srcSet={`${appAppStoreIconUrl}.png`} type="image/png"/>
                        <img src={`${appAppStoreIconUrl}.jpg`} alt="Apple Store" style={{height: iconSize}} />
                    </picture>
                </a>
                <a href={appGooglePlayUrl} target="_blank">
                    <picture>
                        <source srcSet={`${appGooglePlayIconUrl}.webp`} type="image/webp"/>
                        <source srcSet={`${appGooglePlayIconUrl}.png`} type="image/png"/>
                        <img src={`${appGooglePlayIconUrl}.jpg`} alt="Google Play" style={{height: iconSize}} />
                    </picture>
                </a>
            </div>
        </div>
    )
};

export const DownloadAppSmall = ({ className }) => {
    const iconSize = '40px'; 
    
    return (
        <div
            className={classNames('d-flex flex-column text-center justify-content-center p-3', { [className]: !!className })}
            style={{
                backgroundColor: '#fff3cd',
                borderColor: '#ffeeba'
            }}
        >
            <div className="d-flex justify-content-center mb-2">
                <div className="d-flex align-items-center">
                    <img src={ShopIcon} className="d-inline-block mr-2" style={{ width: '35px' }}
                         alt="Fast Buyer" /> <h5 className="m-0">Fast Buyer App</h5>
                </div>
            </div>

            <h3 className="font-weight-bold">
                It's easier <span className="text-danger">on the app.</span>
            </h3>
            <h5>
                Your favorite restaurants in one tap.
            </h5>

            <div className="d-flex flex-column flex-md-row justify-content-center mt-2" style={{ gap: '1rem' }}>
                <a href={appAppStoreUrl} target="_blank">
                    <picture>
                        <source srcSet={`${appAppStoreIconUrl}.webp`} type="image/webp" />
                        <source srcSet={`${appAppStoreIconUrl}.png`} type="image/png" />
                        <img src={`${appAppStoreIconUrl}.jpg`} alt="Apple Store" style={{ height: iconSize }} />
                    </picture>
                </a>
                <a href={appGooglePlayUrl} target="_blank">
                    <picture>
                        <source srcSet={`${appGooglePlayIconUrl}.webp`} type="image/webp" />
                        <source srcSet={`${appGooglePlayIconUrl}.png`} type="image/png" />
                        <img src={`${appGooglePlayIconUrl}.jpg`} alt="Google Play" style={{ height: iconSize }} />
                    </picture>
                </a>
            </div>
        </div>
    )
};